export const MODALS = {
	CREATE_CAMPAIGN_MODAL: 'CREATE_CAMPAIGN_MODAL',
}